import { GridItem } from '../../../../components/layout/ItemGrid'
import PlaceholderCard from '../../../../components/cards/PlaceholderCard'

const PlaceholderItem = () => {
  return (
    <GridItem widthOverride={{ xxxl: '33.33%' }}>
      <PlaceholderCard portrait={false} />
    </GridItem>
  )
}

type NPlaceholderItemsProps = {
  count: number
}

export const NPlaceholderItems = ({ count }: NPlaceholderItemsProps) => {
  return (
    <>
      {[...Array(count)].map((e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <PlaceholderItem key={i} />
      ))}
    </>
  )
}
